import Axios from "Services/Auth/AxiosInterceptors";

const get = async (path, params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "" && v !== false) qs.set(k, v);
  });
  const q = qs.toString();
  const {
    data: { result },
  } = await Axios.get(`/admin/ops/${path}${q ? `?${q}` : ""}`);
  return result;
};

const post = async (path, body = {}) => {
  const {
    data: { result },
  } = await Axios.post(`/admin/ops/${path}`, body);
  return result;
};

export const GetOpsOverview = ({ range, force } = {}) => get("overview", { range, force });
export const GetOpsEconomics = ({ range, force } = {}) => get("economics", { range, force });
export const GetOpsCareQuality = ({ range, force } = {}) => get("care-quality", { range, force });
export const GetOpsHealth = ({ force } = {}) => get("health", { force });
export const GetOpsLobby = ({ range, force } = {}) => get("lobby", { range, force });
export const GetOpsDoctors = ({ range, force } = {}) => get("doctors", { range, force });
export const GetOpsPrescriptions = ({ range, page, resolvedPage, force } = {}) =>
  get("prescriptions", {
    range,
    page: page > 1 ? page : undefined,
    resolvedPage: resolvedPage > 1 ? resolvedPage : undefined,
    force,
  });
export const ResolveOpsPrescription = ({ orderId, notes } = {}) =>
  post(`prescriptions/${orderId}/resolve`, { notes });
export const GetOpsReviews = ({ range, page, force } = {}) =>
  get("reviews", { range, page, force });
export const GetOpsInsights = ({ range, force } = {}) => get("insights", { range, force });
export const GetOpsAnalytics = ({ range, force } = {}) => get("analytics", { range, force });
export const GetOpsPayments = ({ range, force } = {}) => get("payments", { range, force });
export const GetOpsUsersPatients = ({ range, page, sort, order, search, force } = {}) =>
  get("users/patients", { range, page: page > 1 ? page : undefined, sort, order, search, force });
export const GetOpsUsersProviders = ({ range, page, sort, order, search, force } = {}) =>
  get("users/providers", { range, page: page > 1 ? page : undefined, sort, order, search, force });
export const GetOpsStateCoverage = ({ range, force } = {}) =>
  get("state-coverage", { range, force });
export const GetOpsDoctorCoverage = ({ doctorId, range } = {}) =>
  get(`doctors/${doctorId}/coverage`, { range });

export const GetOpsAlerts = ({ force } = {}) => get("alerts", { force });
export const GetOpsAlertDetail = ({ key, page, force } = {}) =>
  get(`alerts/${key}`, { page: page > 1 ? page : undefined, force });

export const GetOpsPatients = ({ range, status, stateId, from, to, search, page, force } = {}) =>
  get("patients", {
    range,
    status,
    stateId,
    from,
    to,
    search,
    page: page > 1 ? page : undefined,
    force,
  });
